export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Calcular el ahorro en Walutomat',
    rangeFrom: 'Quiero',
    forBuy: 'para',
    forSell: 'a',
    directionBuy: 'Comprar',
    directionSell: 'Vender',
    payText: 'usted pagará',
    sellText: 'recibirá',
    buySelect: 'comprar',
    sellSelect: 'vender',
    rateText: 'Tipo de cambio',
    amountText: 'Importe',
    includes: 'Incluye',
    commission: '{{commission}}% comisión',
    howItWorks: '',
    banksComapreOpen: 'Comparar con otros',
    banksComapreClose: 'Colapsar la lista',
    savingsMonthly: 'Ahorra incluso una vez con Walutomat',
    savingsYearly: 'sustituyendo durante todo el año, todos los meses.',
    conjunction: 'y',
    serverError: 'Error de comunicación del servidor',
    unsupportedPair: 'Actualmente no ofrecemos tarifas para el par de divisas seleccionado.',
    infoError: {
      exchange: 'En Walutomat.pl puede intercambiar directamente',
      transactionFee:
        'y viceversa. Tal transacción en el banco se asocia con una alta tasa, por lo general llega incluso a 5-10% de la cantidad de cambio.',
    },
    spinnerError: 'Hubo un problema con la descarga de datos',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Comprueba los tipos de cambio y{{nbsp}}cambia divisas en{{nbsp}}Walutomat – rápido y{{nbsp}}ventajoso.',
    actualRate: 'Tipo de cambio actual',
    exchangeAmount: 'Valor del cambio',
    buySelect: 'Comprar',
    sellSelect: 'Vendo',
    buttonText: 'Cambiar',
    buyRateTooltip:
      'Este tipo de cambio significa que te venderemos {{buyCurrency}} por {{exchangeRate}} {{sellCurrency}}. Cuanto más bajo sea, mejor para ti. Lo actualizamos cada 30 segundos.',
    sellRateTooltip:
      'Este tipo de cambio significa que te compraremos {{buyCurrency}} a {{exchangeRate}} {{sellCurrency}}. Cuanto más alto sea, mejor para ti. Lo actualizamos cada 30 segundos.',
  },
  formValidation: {
    emptyField: 'El campo no puede estar vacío',
    requiredField: 'El campo es obligatorio',
    passwordToShort: 'La contraseña debe tener 8 caracteres',
    emailNotValid: 'El campo debe contener una dirección de correo electrónico válida',
    emailReserved: 'La dirección de correo electrónico ya está ocupada',
    rateEmpty: 'Todos los campos deben estar completos',
    serverUnknownError: 'Error de comunicación con el servidor',
    invalidCharacters: 'El campo contiene caracteres no válidos',
    phoneNotValid: 'El número de teléfono es incorrecto',
    checkBoxBelow: 'Por favor, marque la casilla de abajo para enviar un mensaje',
  },
  password: {
    show: 'mostrar',
    hide: 'ocultar',
  },
  howItWorks: {
    showButton: 'Mostrar más',
    hideButton: 'Mostrar menos',
  },
}
